import { HOME_ROUTE } from '@/routes/route-paths';
import { Box, Button, Typography } from '@montugroup/design-system';
import styled from '@mui/material/styles/styled';
import { Link } from 'react-router-dom';

const ROSContainer = styled(Box)`
  height: 100vh;
  align-self: center;
  display: flex;
`;

const CenterBox = styled(Box)`
  align-self: center;
  justify-content: center;
`;

const Card = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  wordWrap: 'break-word',
  backgroundColor: theme.palette.common.white,
  backgroundClip: 'border-box',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
}));

const ROSCard = styled(Card)(({ theme }) => ({
  textAlign: 'center',
  boxShadow: theme.shadows[1],
  paddingBottom: theme.spacing(6),
}));

const CardBody = styled(Box)(({ theme }) => ({
  flex: '1 1 auto',
  minHeight: '1px',
  padding: theme.spacing(5),
}));

const CardTitle = styled(Typography)`
  margin-bottom: 0.75rem;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.2;
`;

const Refillordersuccess = () => {
  return (
    <ROSContainer>
      <CenterBox>
        <ROSCard sx={{ maxWidth: '500px' }}>
          <CardBody>
            <CardTitle>
              Your order invoice has been emailed to you.
              <br /> Your medication will be shipped upon payment.
            </CardTitle>
            <Button variant="outlined" component={Link} to={HOME_ROUTE}>
              Back to Home
            </Button>
          </CardBody>
        </ROSCard>
      </CenterBox>
    </ROSContainer>
  );
};

export default Refillordersuccess;
